import React from 'react';
import { Button } from 'antd';
import { Algorithm } from '../../../types';
import { Flow } from '../../../types/flow';
import { isMultiflow } from '../../../lib/util';
import { Link } from 'react-router-dom';

export const getTableColumns = (
  algorithm: Algorithm,
  onClickUrl: (flow: Flow) => any,
  onDelete: (e: any, flow: Flow) => any,
  onRename: (e: any, flow: Flow) => any
) => {
  return [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      render: (text: string, record: Flow) => (
        <span>
          <Link to={onClickUrl(record)}>{record.name}</Link>
        </span>
      ),
    },
    ...(isMultiflow(algorithm)
      ? [
          {
            title: 'Multiflow name',
            key: 'multiflowName',
            dataIndex: 'model',
            render: (text: string, record: Flow) => <span>{record.multiflowName}</span>,
          },
        ]
      : [
          {
            title: 'Model',
            key: 'model',
            dataIndex: 'model',
            render: (text: string, record: Flow) => <span>{record.model.name}</span>,
          },
          {
            title: 'Label count',
            key: 'labels',
            dataIndex: 'labels',
            render: (text: string, record: Flow) => {
              return (
                <span>
                  {record.model.info && record.model.info.annotationTypes
                    ? record.model.info.annotationTypes.length
                    : 0}
                </span>
              );
            },
          },
          {
            title: 'Rules',
            key: 'rules',
            dataIndex: 'rules',
            render: (text: string, record: Flow) => {
              return (
                <span>{record.rules && Object.values(record.rules).reduce((prev, val) => prev + val.length, 0)}</span>
              );
            },
          },
        ]),

    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: Flow) => (
        <span>
          <Button type="link" size="small" onClick={e => onRename(e, record)}>
            Rename
          </Button>
          <Button type="link" size="small" onClick={e => onDelete(e, record)}>
            Delete
          </Button>
        </span>
      ),
    },
  ];
};
